<template>
    <!-- 
    1.화면ID    : MCF_NT_001
    2.화면명    : News@Report등록
    3.작성자    : 최원경 부장
    4.화면설명  : News@Report를 등록 관리한다. 
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    --> 
    <div class="content-wrap">
  
      <div class="register-wrap">
        <div class="row mb-3">
          <ElLabel name="제목" classNm="col-sm-2 col-form-label">
            <template #end="{id}">
                <div class="col-sm-10">
                    {{ state.params.title }}
                </div>
                <!-- <ElInput :id="id" v-model="state.params.title" ref="titleRef"/> -->
            </template>
          </ElLabel>
          
        </div>
        <div class="row mb-3">
          <ElLabel name="작성자" classNm="col-sm-2 col-form-label"/>
          <div class="col-sm-10">
            {{ state.params.reg_user_nm }}
          </div>
        </div>
        <div class="row mb-3">
          <ElLabel name="내용" classNm="col-sm-2 col-form-label"/>
            <Editor v-model="state.params.content" editorStyle="height: 320px" readonly ></Editor>
        </div>
      </div>
  
      <div class="text-end py-3">
        <ElButton type="primary" @click="router.back()">이전</ElButton>
      
      </div>
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
              파일첨부
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              <FileUpload
                ref="fileUploadRef"
                :can-update="false"
                @return="res => getFileList(res)"
                @deleteData="res => getDeleteFile(res)"
              />
            </div>
          </div>
        </div>
      </div>             
    </div>
  </template>
       
<script setup>   
import {reactive,ref,onBeforeMount} from 'vue'
import Editor          from 'primevue/editor';
import { useRouter } from "vue-router";
import FileUpload from '@/components/common/FileUpload.vue';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { nwsSelect, nwsEdit } from '@/api/nws';
import { fileList } from '@/api/file';

const router = useRouter();
const fileUploadRef = ref()
const titleRef = ref();
const contentRef = ref()

onBeforeMount(async ()=> {
    let nws_seq = history.state.nws_seq;

    if(nws_seq){
        let param = {
            nws_seq : nws_seq
        }
        try {
            setIsLoading(true)
            const res = await nwsSelect(param)
            let detailCf = res.rtn

            state.params.nws_seq = detailCf.nws_seq
            state.params.title = detailCf.title
            state.params.reg_id = detailCf.reg_id
            state.params.reg_user_nm = detailCf.reg_user_nm
            state.params.content = detailCf.content

            state.file_seq_grp = detailCf.file_seq_grp

            //첨부파일이 존재할경우 파일리스트 조회api 호출
            if (detailCf.file_seq_grp != '' && detailCf.file_seq_grp != null && detailCf.file_seq_grp != undefined) {
                let apiParam = {
                    file_seq_grp: detailCf.file_seq_grp
                }
                const resFileList = await fileList(apiParam)
                fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
            }
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoading(false)
        }
    }
})   


const state = reactive({
    params : {
            nws_seq : '',
            title : '',
            reg_id : '',
            reg_user_nm: '',
            content : '',
            file_seq_grp : '',
            del_yn : 'N',
            attachFileVO : {
                file_div_id : '10',
                file_seq: '',       //추가 된 파일 seq 전송
                del_file_seq: ''    // 삭제해야 할 파일 seq 전송
            }
        },
        tmpFileList: [],
    //파일 첨부 데이터
    fileList : [],      
    delFileList : [],
    file_seq_grp : '', 
    userId : userStore.user.userId,
    typeName : ''

})


</script>
          
<style scoped>
div.form-control {
    height: 240px;
    overflow-y: auto;
}
</style>